import React from 'react';
import './MyService.css'
import meren from '../images/maren.jpg'
import html from '../images/html.jpg'
import web from '../images/web.jpg'


const MyService = () => {
    return (
        <div>
             <div className="container mt-5 mb-5 ">
        <h1 className="text-center font pt-5"> Chose I Provide</h1>
        <div className="services ">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-6 col-lg-4 col-sm-12">
              <div className="service test">
                <div>
                  <div>
                    <img src={web} alt="" />
                  </div>
                  <h3 className='title-style'>Web Designing</h3>
                  <p className="paragrap">
                    I am  in web designing. I can add functionality
                    besides designing a webpage. I use HTML, CSS, Bootstrap,
                     React JS for it. You can see some of my works
                    below
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-sm-12">
              <div className="service " >
                <div>
                  <img className="mern-image " width='20px' src={meren} alt="" />
                  <h3  className='title-style'>MERN Stack Developer</h3>
                  <p className="paragrap">
                    I am a MERN stack web developer. I use MongoDB for database
                    and Express JS, Node Js for server side work. You can see i
                    have done some MERN project.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-sm-12">
              <div className="service" >
                <div>
                  <div>
                    <img src={html} alt="" />
                  </div>
                  <h3  className='title-style'> HTML AND CSS</h3>
                  <p className="paragrap">
                    I can covert any  design to a responsive webpage. I use
                    HTML, CSS, Bootstrap,  React JS for it. You can
                    see some of my works in portfolio tab in this website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
    );
};

export default MyService;